import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "convex/react";
import { api } from "@convex/_generated/api";
import { formatMinor } from "@convex/payments/domain";
import { Receipt, ArrowLeft, CaretRight } from "@phosphor-icons/react";
import { getStoredUserSession } from "@shared/hooks/useUserSession";
import { trackEvent } from "@shared/lib/posthog-lazy";
import { formatPaidAt } from "../../lib/money";

/** Chitanțele plăților făcute cu contul (RECEIPT-002). */

export const Route = createFileRoute("/app/receipts")({
  component: ReceiptsPage,
});

function ReceiptsPage() {
  const { userId, sessionToken } = getStoredUserSession();
  const receipts = useQuery(api.receipts.listUserReceipts, userId && sessionToken ? { userId, sessionToken, limit: 100 } : "skip");

  if (!userId || !sessionToken) {
    window.location.href = "/auth/login";
    return null;
  }

  return (
    <div className="min-h-screen bg-background pb-24 px-4 pt-4">
      <div className="flex items-center gap-3 mb-4">
        <Link to="/app/profile" search={{ success: false, canceled: false, session_id: undefined }} className="p-2 rounded-lg bg-white shadow-sm" aria-label="Înapoi">
          <ArrowLeft size={20} />
        </Link>
        <h1 className="text-xl font-bold text-text">Chitanțe</h1>
      </div>

      {receipts === undefined && (
        <div className="w-10 h-10 mx-auto mt-10 animate-spin motion-reduce:animate-none rounded-full border-4 border-primary border-t-transparent" />
      )}

      {receipts && receipts.length === 0 && (
        <div className="bg-white rounded-2xl p-6 text-center shadow-sm">
          <Receipt size={40} className="mx-auto text-primary mb-3" />
          <p className="font-semibold text-text">Nicio chitanță încă</p>
          <p className="text-sm text-text-muted mt-1">Plățile confirmate prin RoPay apar aici.</p>
        </div>
      )}

      <div className="space-y-2">
        {receipts?.map((r) => (
          <Link
            key={r.id}
            to="/app/receipts/$receiptId"
            params={{ receiptId: r.id }}
            onClick={() => void trackEvent("receipt_opened")}
            className="flex items-center gap-3 bg-white rounded-2xl p-4 shadow-sm"
            data-testid="receipt-row"
          >
            <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Receipt size={20} className="text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-text truncate">{r.merchantName}</p>
              <p className="text-xs text-text-muted">
                {formatPaidAt(r.paidAt)} · {r.receiptNumber}
              </p>
            </div>
            <p className="font-bold text-text whitespace-nowrap">{formatMinor(r.amountMinor)}</p>
            <CaretRight size={16} className="text-text-muted" />
          </Link>
        ))}
      </div>
    </div>
  );
}
